import { render, staticRenderFns } from "./object-lister.vue?vue&type=template&id=22a8199e&scoped=true"
import script from "./object-lister.vue?vue&type=script&lang=js"
export * from "./object-lister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a8199e",
  null
  
)

export default component.exports